module.exports = __webpack_public_path__ + "media/images/constellation-bg@2x-7802bb69.jpg";